import { withTranslation } from "react-i18next";
import NoticeModal from "./NoticeModal";

export default withTranslation()(NoticeModal)